import template from "./deployment-update.html";
import controller from "./deployment-update.controller";
import "./deployment-update.scss";

const DeploymentUpdateComponent = {
    template,
    controller,
    controllerAs: "DeploymentUpdate"
};

export default DeploymentUpdateComponent;


// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-update/deployment-update.component.js